import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  /** İkon (mockup: clipboard-check, file-text, calendar, shield-check…). 22px, fg-soft. */
  icon?: ReactNode;
  /** Kart İÇİNDE kullanım (mockup bölüm boş durumları): 24px dikey dolgu yerine tam 40px. */
  padding?: "default" | "compact";
  className?: string;
}

/**
 * UI Tur 2 §5: ikon kutusu 48px (muted zemin, radius-xl) + başlık 15/600 fg-strong +
 * açıklama 13 fg-muted (~40ch) + isteğe bağlı `action` (secondary sm). Dikey ortalı,
 * varsayılan 40px dolgu; kart içi kullanımda (`padding="compact"`) 24px.
 */
export function EmptyState({
  title,
  description,
  action,
  icon,
  padding = "default",
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 text-center",
        padding === "compact" ? "py-6" : "py-10",
        className,
      )}
    >
      {icon ? (
        <span
          aria-hidden="true"
          className="mb-1 flex size-12 items-center justify-center rounded-xl bg-muted text-fg-soft [&_svg]:size-[22px]"
        >
          {icon}
        </span>
      ) : null}
      <p className="text-[15px] font-semibold text-fg-strong">{title}</p>
      {description ? <p className="max-w-[40ch] text-[13px] text-fg-muted">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
